import { c as _c } from "react/compiler-runtime";
import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Tooltip } from '@systemeio/ui';
import FunnelStepActions from 'modules/funnels/funnel/components/funnel-actions';
import TestIconWithoutBg from 'modules/funnels/funnel/icons/test-withot-bg-icon';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelStepTypeIcon } from 'modules/funnels/funnel/utils/get-funnel-step-type-icon';
import React from 'react';
import { FunnelStepTypeTitlesEnum } from 'shared/enums/funnel-step-type-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { CheckIcon, WarningIcon } from '@systemeio/ui/icons';
interface DraggableFunnelStepProps {
  funnelStep: FunnelStepInterface;
  selectedFunnelStep: FunnelStepInterface | null;
  selectFunnelStep: (funnelId: FunnelStepInterface) => void;
}
const animateLayoutChanges: AnimateLayoutChanges = args => defaultAnimateLayoutChanges({
  ...args,
  wasDragging: true
});
function DraggableFunnelStep(t0) {
  const $ = _c(56);
  const {
    funnelStep,
    selectedFunnelStep,
    selectFunnelStep
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== funnelStep.id) {
    t1 = {
      id: funnelStep.id,
      animateLayoutChanges
    };
    $[0] = funnelStep.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transition,
    transform
  } = useSortable(t1);
  let t2;
  if ($[2] !== transform) {
    t2 = CSS.Translate.toString(transform);
    $[2] = transform;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isDragging ? 0.5 : undefined;
  let t4;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== transition) {
    t4 = {
      transition,
      transform: t2,
      opacity: t3
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = transition;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const style = t4;
  const isGoalFunnelStepOfAnySplitTest = funnelStep.goalFunnelStepOfAnySplitTest;
  const isNotGoalInSplitTest = !funnelStep.goalFunnelStepOfAnySplitTest && (funnelStep.inRunningSplitTest || funnelStep.currentSplitTest?.id);
  const t5 = `lg:hover:bg-brand-primary/[0.06] border-[rgb(var(--text-primary))]/20 relative flex cursor-pointer justify-between border-b-[1px] px-[15px] py-[18px] last:border-b-transparent ${selectedFunnelStep?.id === funnelStep.id ? "bg-brand-primary/[0.06]" : ""}`;
  let t6;
  if ($[8] !== style) {
    t6 = {
      ...style
    };
    $[8] = style;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== funnelStep || $[11] !== selectFunnelStep) {
    t7 = () => selectFunnelStep(funnelStep);
    $[10] = funnelStep;
    $[11] = selectFunnelStep;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== funnelStep.type) {
    t8 = getFunnelStepTypeIcon(funnelStep.type);
    $[13] = funnelStep.type;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <div className="mt-1">{t8}</div>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== funnelStep.name) {
    t10 = <Tooltip mode="overflow" label={funnelStep.name} wrapperClassName="flex w-full h-full" className="font-inter text-[15px] font-semibold leading-5 " popoverClassName="max-w-[250px]" key={funnelStep.name}>{funnelStep.name}</Tooltip>;
    $[17] = funnelStep.name;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== funnelStep.page) {
    t11 = !funnelStep.page && <WarningIcon className="h-[20px] w-[16px] shrink-0 fill-[rgb(var(--fill-primary))]" />;
    $[19] = funnelStep.page;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = FunnelStepTypeTitlesEnum[funnelStep.type];
  let t13;
  if ($[21] !== t || $[22] !== t12) {
    t13 = t(t12);
    $[21] = t;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13) {
    t14 = <span className="text-text-tertiary truncate text-sm font-normal leading-4">{t13}</span>;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t14) {
    t15 = <div className="flex items-center gap-1">{t11}{t14}</div>;
    $[26] = t11;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t10 || $[30] !== t15) {
    t16 = <div className="flex max-w-[200px] flex-col gap-1">{t10}{t15}</div>;
    $[29] = t10;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16 || $[33] !== t9) {
    t17 = <div className="flex items-start gap-3">{t9}{t16}</div>;
    $[32] = t16;
    $[33] = t9;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== isGoalFunnelStepOfAnySplitTest || $[36] !== t) {
    t18 = isGoalFunnelStepOfAnySplitTest && <div className="absolute left-0.5 top-0.5"><Tooltip label={t("dashboard.funnel.split_tests.goal_page_tooltip")} popoverClassName="min-w-max" mode="hover"><CheckIcon className="stroke-[rgb(var(--fill-primary))] h-4 w-4" /></Tooltip></div>;
    $[35] = isGoalFunnelStepOfAnySplitTest;
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== funnelStep.inRunningSplitTest || $[39] !== isNotGoalInSplitTest || $[40] !== t) {
    t19 = isNotGoalInSplitTest && <div className="absolute left-0.5 top-0.5"><Tooltip label={funnelStep.inRunningSplitTest ? t("dashboard.funnel.split_tests.running_tooltip") : t("dashboard.funnel.split_tests.selected_tooltip")} popoverClassName="min-w-max" mode="hover"><TestIconWithoutBg className="hover:fill-bg-brand-primary/[0.06]" /></Tooltip></div>;
    $[38] = funnelStep.inRunningSplitTest;
    $[39] = isNotGoalInSplitTest;
    $[40] = t;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== funnelStep || $[43] !== selectFunnelStep) {
    t20 = <FunnelStepActions funnelStep={funnelStep} selectFunnelStep={selectFunnelStep} />;
    $[42] = funnelStep;
    $[43] = selectFunnelStep;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== attributes || $[46] !== listeners || $[47] !== setNodeRef || $[48] !== t17 || $[49] !== t18 || $[50] !== t19 || $[51] !== t20 || $[52] !== t5 || $[53] !== t6 || $[54] !== t7) {
    t21 = <li className={t5} ref={setNodeRef} style={t6} {...attributes} {...listeners} onClick={t7}>{t17}{t18}{t19}{t20}</li>;
    $[45] = attributes;
    $[46] = listeners;
    $[47] = setNodeRef;
    $[48] = t17;
    $[49] = t18;
    $[50] = t19;
    $[51] = t20;
    $[52] = t5;
    $[53] = t6;
    $[54] = t7;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  return t21;
}
export default DraggableFunnelStep;